import { combineReducers } from 'redux-immutable';

import configurationReducer from './configuration/reducer';
import fundingSearchOverviewReducer from './fundingSearchOverview/reducer';
import totalApprovedReducer from './totalApproved/reducer';
import searchesRequiringAttentionReducer from './searchesRequiringAttention/reducer';
import leadsOverviewReducer from './leadsOverview/reducer';
import responseTimeReducer from './responseTime/reducer';
import casesSummaryReducer from './casesSummary/reducer';
import latestCasesReducer from './latestCases/reducer';
import activitiesReducer from './activities/reducer';
import actionsReducer from './actions/reducer';

export {
  getConfigurationRequest,
  getConfigurationFailure,
  getConfigurationSuccess,
} from './configuration/reducer';

export {
  fundingSearchOverviewRequest,
  fundingSearchOverviewSuccess,
  fundingSearchOverviewFailure,
} from './fundingSearchOverview/reducer';

export {
  totalApprovedRequest,
  totalApprovedSuccess,
  totalApprovedFailure,
} from './totalApproved/reducer';

export {
  searchesRequiringAttentionRequest,
  searchesRequiringAttentionSuccess,
  searchesRequiringAttentionFailure,
} from './searchesRequiringAttention/reducer';

export {
  leadsOverviewRequest,
  leadsOverviewSuccess,
  leadsOverviewFailure,
} from './leadsOverview/reducer';

export {
  responseTimeRequest,
  responseTimeSuccess,
  responseTimeFailure,
} from './responseTime/reducer';

export {
  requestCasesSummary,
  requestCasesSummarySuccess,
  requestCasesSummaryFailure,
} from './casesSummary/actions';

export {
  requestLatestCases,
  requestLatestCasesSuccess,
  requestLatestCasesFailure,
} from './latestCases/actions';

export {
  requestActivities,
  requestActivitiesSuccess,
  requestActivitiesFailure,
} from './activities/actions';

export { requestActions, requestActionsSuccess, requestActionsFailure } from './actions/actions';

export default combineReducers({
  configuration: configurationReducer,
  fundingSearchOverview: fundingSearchOverviewReducer,
  totalApproved: totalApprovedReducer,
  searchesRequiringAttention: searchesRequiringAttentionReducer,
  leadsOverview: leadsOverviewReducer,
  responseTime: responseTimeReducer,
  casesSummary: casesSummaryReducer,
  latestCases: latestCasesReducer,
  activities: activitiesReducer,
  actions: actionsReducer,
});
